const TABLE = {
  ACTION_TYPE: {
    ADD: 'add',
    VIEW: 'view',
    EDIT: 'edit',
    DELETE: 'delete'
  }
}

export const COMPONENT = {
  TABLE
}